import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGS, setLanguage, type Lang } from '../i18n'

const LABELS: Record<Lang, string> = { ko: '한국어', en: 'English' }

interface Props {
  /** 어두운 배경(헤더 등)에서는 dark */
  tone?: 'light' | 'dark'
  className?: string
}

/** 한국어 / English 전환. 선택은 localStorage 에 저장되어 다음 방문에도 유지된다. */
export default function LanguageSwitcher({ tone = 'light', className = '' }: Props) {
  const { i18n, t } = useTranslation()
  const current = (i18n.resolvedLanguage ?? i18n.language) as Lang
  const dark = tone === 'dark'

  return (
    <span
      role="group"
      aria-label={t('common.language')}
      className={`inline-flex overflow-hidden rounded border text-[11px] font-medium ${
        dark ? 'border-slate-600' : 'border-slate-300'
      } ${className}`}
    >
      {SUPPORTED_LANGS.map((lang) => {
        const active = current === lang
        return (
          <button
            key={lang}
            type="button"
            lang={lang}
            aria-pressed={active}
            onClick={() => setLanguage(lang)}
            className={`px-2 py-0.5 transition ${
              active
                ? dark
                  ? 'bg-slate-200 text-slate-900'
                  : 'bg-slate-800 text-white'
                : dark
                  ? 'bg-transparent text-slate-300 hover:bg-slate-700'
                  : 'bg-white text-slate-500 hover:bg-slate-50'
            }`}
          >
            {LABELS[lang]}
          </button>
        )
      })}
    </span>
  )
}
